import type { SVGProps } from 'react';
const DawnFlagCO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CO_svg__a)">
      <g filter="url(#dawn-flag-CO_svg__b)">
        <path
          fill="#0748AE"
          fillRule="evenodd"
          d="M0 11.733h22V7.467H0z"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#dawn-flag-CO_svg__c)">
        <path
          fill="#DE2035"
          fillRule="evenodd"
          d="M0 16h22v-4.267H0z"
          clipRule="evenodd"
        />
      </g>
      <path fill="#FFD935" fillRule="evenodd" d="M0 7.467h22V0H0z" clipRule="evenodd" />
    </g>
    <defs>
      <filter
        id="dawn-flag-CO_svg__b"
        width={22}
        height={4.267}
        x={0}
        y={7.467}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_442" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_442" result="shape" />
      </filter>
      <filter
        id="dawn-flag-CO_svg__c"
        width={22}
        height={4.267}
        x={0}
        y={11.733}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_442" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_442" result="shape" />
      </filter>
    </defs>
  </svg>
);
export default DawnFlagCO;
